module.exports = __webpack_public_path__ + "img/newsImg.9a6b17b7.png";